var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodeCanvasLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 680,
    height: 778.43,
    viewBox: "0 0 179.92 205.96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34.184 -24.408)",
    display: "none",
    fill: "none",
    stroke: "#000",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170.17,
    cy: 97.985,
    r: 11.422
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.83,
    cy: 141.33,
    r: 11.422
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.05 -13.261)",
    fill: "none",
    stroke: "#fca311",
    strokeWidth: 11
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 91.715,
    cy: 140.26,
    r: 11.422
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.11,
    cy: 98.164,
    r: 11.422
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.738 151.19s0.1273 9.6607 0.35826 23.687-7.443 28.676-25.909 28.975-26.435-14.773-26.337-28.233c0.09732-13.46-0.24767-53.243-0.1484-77.915 0.05778-14.359 6.7166-29.471 25.973-29.252s23.058 15.435 29.137 24.643c6.0788 9.2078 29.268 48.861 39.924 65.09 5.5085 8.3891 15.814 20.263 28.587 20.392s26.549-7.255 26.819-26.664-0.0799-78.404-0.0255-93.881c0.0342-9.7285-7.6968-28.201-26.691-28.124-18.994 0.07778-24.869 18.328-24.899 26.332-0.0578 15.043-0.17913 29.997-0.17913 29.997"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeCanvasLogo);
export default __webpack_public_path__ + "static/media/NodeCanvasLogo.46c5a831033e44492a7364af479cf1f0.svg";
export { ForwardRef as ReactComponent };